export default class ContactSummaryDto {
    firstName = '';
    lastName = '';
    emailAddress = '';
}
